/**
 * @module constants/AudioPlayer
 */

export const AudioPlayerActions = Object.freeze({
  // audio player commands
  AUDIO_PLAY_TRACK: 'AUDIO_PLAY_TRACK',
  AUDIO_PRELOAD_TRACK: 'AUDIO_PRELOAD_TRACK',
  REPLAY: 'AUDIO_REPLAY',
  PAUSE: 'AUDIO_PAUSE',
  SET_VOLUME: 'AUDIO_SET_VOLUME',
  SET_CURRENT_TIME: 'SET_CURRENT_TIME',
  SCRUB_AUDIO: 'SCRUB_AUDIO',
  MUTE: 'AUDIO_MUTE',
  UNMUTE: 'AUDIO_UNMUTE',
  CLEAR: 'AUDIO_CLEAR',
  SET_ACTIVE_TRACK_URL: 'SET_ACTIVE_TRACK_URL',
  HANDLE_POST_URL_UPDATE: 'HANDLE_POST_URL_UPDATE',

  // audio player updates
  PLAYING: 'AUDIO_PLAYING',
  ENDED: 'AUDIO_ENDED',
  PAUSED: 'AUDIO_PAUSED',
  RESUMED: 'AUDIO_RESUMED',
  UPDATE: 'AUDIO_UPDATE',
  DURATION: 'AUDIO_DURATION',
  LOAD: 'AUDIO_LOAD',
  RESET: 'AUDIO_RESET',
  PROGRESS: 'AUDIO_PROGRESS',
  CAN_PLAY: 'AUDIO_CAN_PLAY',
  ERROR: 'AUDIO_ERROR',

  SET_WAKE_LOCK: 'AUDIO_SET_WAKE_LOCK',
  TRACK_END_ERROR: 'TRACK_END_ERROR',
  AUDIO_INITIALIZED: 'AUDIO_INITIALIZED',
  AUDIO_ACTIVE_PROVIDER: 'AUDIO_ACTIVE_PROVIDER',
  PLAYBACK_METRICS: 'PLAYBACK_METRICS',
} as const);

export default AudioPlayerActions;

// TODO: WEBCLIENT-4964 eventually track down all these references so this isn't global
export * from '../domains/playback/audio/constants';
